import React from 'react';
import ServiceLandingPage from './ServiceLandingPage';
import enfermeriaImg from '../../assets/general.jpg';

const EnfermeriaZapopan = () => {
  const pageData = {
    title: "Enfermería a Domicilio en Zapopan",
    metaDescription: "Servicio de enfermería a domicilio en Zapopan. Atención profesional para adultos mayores y pacientes en recuperación. Cobertura en toda la zona.",
    heroTitle: "Enfermería a Domicilio en Zapopan",
    heroSubtitle: "Atención médica profesional en todas las colonias de Zapopan",
    description: "Geriatría Serena ofrece servicios completos de enfermería a domicilio en todo Zapopan. Ya sea que vivas en Providencia, Chapalita, Ciudad Granja, Tesistán o cualquier otra zona, llevamos atención médica de calidad directamente a tu hogar.",
    benefits: [
      "Cobertura en todo Zapopan y zona metropolitana",
      "Tiempos de respuesta rápidos",
      "Personal que conoce bien la zona",
      "Servicio disponible 24/7",
      "Atención en español",
      "Coordinación con hospitales de Zapopan",
      "Precios accesibles para familias locales",
      "Sin cargos extra por traslado en la zona"
    ],
    features: [
      {
        title: "Zona Providencia",
        description: "Cobertura completa en Providencia, Country Club y colonias aledañas"
      },
      {
        title: "Zona Chapalita",
        description: "Servicio en Chapalita, Jardines del Bosque y Residencial Victoria"
      },
      {
        title: "Zona Norte",
        description: "Atención en Tesistán, Copala, Base Aérea y alrededores"
      },
      {
        title: "Zona Poniente",
        description: "Ciudad Granja, Santa Margarita, Bugambilias y más"
      },
      {
        title: "Centros Comerciales",
        description: "Cerca de Andares, Galerías, La Gran Plaza y centros médicos"
      },
      {
        title: "Hospitales Cercanos",
        description: "Coordinación con Hospital Ángeles, Puerta de Hierro y más"
      }
    ],
    faqs: [
      {
        question: "¿Cubren todas las colonias de Zapopan?",
        answer: "Sí, damos servicio en todo el municipio de Zapopan: desde Providencia hasta Tesistán, de Chapalita a Ciudad Granja. No importa dónde vivas, llegamos a ti."
      },
      {
        question: "¿Hay costo adicional por servicio en Zapopan?",
        answer: "No cobramos extra por traslado en Zapopan ni en ninguna zona del área metropolitana de Guadalajara."
      },
      {
        question: "¿Cuánto tardan en llegar a mi domicilio?",
        answer: "Para servicios programados, llegamos puntualmente. Para urgencias, podemos estar en tu domicilio en 30-60 minutos dependiendo de la zona y tráfico."
      },
      {
        question: "¿Trabajan con hospitales de Zapopan?",
        answer: "Sí, nos coordinamos con todos los hospitales de la zona: Ángeles, Puerta de Hierro, San Javier, IMSS Zapopan y otros."
      }
    ],
    image: enfermeriaImg,
    relatedBlogSlugs: ['cuidados-geriatricos-zapopan', 'enfermeria-domicilio-guadalajara-2026']
  };

  return <ServiceLandingPage {...pageData} />;
};

export default EnfermeriaZapopan;
